import { render } from "./PentaMarkersResultFileEdit.vue?vue&type=template&id=dea9986a&scoped=true"
import script from "./PentaMarkersResultFileEdit.vue?vue&type=script&lang=js"
export * from "./PentaMarkersResultFileEdit.vue?vue&type=script&lang=js"

import "./PentaMarkersResultFileEdit.vue?vue&type=style&index=0&id=dea9986a&lang=scss&scoped=true"
import "./PentaMarkersResultFileEdit.vue?vue&type=style&index=1&id=dea9986a&lang=scss"
import "./PentaMarkersResultFileEdit.vue?vue&type=style&index=2&id=dea9986a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dea9986a"]])

export default __exports__